import script from "./InvoiceList.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceList.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceList.vue?vue&type=style&index=0&id=be36a55a&lang=css"

const __exports__ = script;

export default __exports__